import React from "react";
import About from "./About";
import heroImage from "./img/prePrimaryHeroImage.png";
const Preprimary = () => {
  return (
    <div style={{ marginBottom: "100px" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="">
              <img src={heroImage} style={{ width: "100%" }} alt="heroImage" />
            </div>
          </div>
        </div>
      </div>
      <About />
    </div>
  );
};

export default Preprimary;
